import dev from './dev';
import utils from './tools';
import http from '../services/http';

export default class inviteService {
  constructor($http) {
    this.$http = $http;
  }

  queryUserInviteInfo(mobilePhone) {
    return http.post('h5/user_invitation_query', {
      mobile_phone: `${mobilePhone}`,
    });
  }
  getShareParam() {
    return http.post('h5/share_param_query');
  }

  inviteCheck(inviterMobilePhone, invitedMobilePhone) {
    return http.post('h5/user_invitation_check', {
      inviter_mobile_phone: inviterMobilePhone,
      invited_mobile_phone: invitedMobilePhone,
    });
  }

  // 添加账号
  addAccount(data) {
    return http.post('h5/user_account_add', data);
  }

  register(data) {
    return http.post('h5/user_relation_add', data);
  }

  verifyCodeGet(mobilePhone) {
    return http.post('h5/sys_verify_code_get', {
      mobile_phone: mobilePhone,
    });
  }

  static getHideMobilePhone(phoneNumber) {
    const phone = `${phoneNumber}`;

    if (!phone) return '';

    if (phone.length === 11) {
      return `${phone.substring(0, 3)}****${phone.substring(7, 11)}`;
    }

    return '';
  }

  /**
   * 创建分享的数据
   */
  buildShareDate(inviteInfo, mobilePhone, env) {
    utils.noop(this);

    return {
      1: {
        shareType: 1,
        title: `熊猫签证送你￥${
          inviteInfo.max_reduce / 100
        } 新人大礼！足不出户办签证~`,
        content: `现在加入，立刻获得￥${
          inviteInfo.max_reduce / 100
        }新人大礼！足不出户办签证~`,
        image:
          'http://webppbb.oss-cn-shenzhen.aliyuncs.com/pdv/imgs/logo-r.png',
        url: `https://${dev}h5.11visa.com/#/invite?mobile_phone=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
      },
      2: {
        shareType: 2,
        title: `熊猫签证送你￥${
          inviteInfo.max_reduce / 100
        } 新人大礼！足不出户办签证~`,
        content: `现在加入，立刻获得￥${
          inviteInfo.max_reduce / 100
        }新人大礼！足不出户办签证~`,
        image:
          'http://webppbb.oss-cn-shenzhen.aliyuncs.com/pdv/imgs/logo-r.png',
        url: `https://${dev}h5.11visa.com/#/invite?mobile_phone=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
      },
      3: {
        shareType: 3,
        title: `熊猫签证送你￥${
          inviteInfo.max_reduce / 100
        } 新人大礼！足不出户办签证~`,
        content: `现在加入，立刻获得￥${
          inviteInfo.max_reduce / 100
        }新人大礼！足不出户办签证~ https://${dev}h5.11visa.com/#/invite?mobile_phone=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
        image:
          'http://webppbb.oss-cn-shenzhen.aliyuncs.com/pdv/imgs/logo-r.png',
        url: `https://${dev}h5.11visa.com/#/invite?mobile_phone=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
      },
    };
  }

  /**
   * 余额页面的分享
   *
   * @param {any} inviteInfo
   * @param {any} dev
   * @returns
   * @memberof inviteService
   */
  buildShareDateForBalancePage(inviteInfo, mobilePhone, env) {
    utils.noop(this);

    return {
      1: {
        shareType: 1,
        title: `熊猫签证送你￥${inviteInfo.max_reduce / 100} 新人大礼！`,
        content: `熊猫签证送你￥${inviteInfo.max_reduce / 100} 新人大礼！`,
        image: 'http://web.11visa.com/pdv/imgs/yaoqing-icon2.png',
        url: `https://${dev}h5.11visa.com/#/invite?uid=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
      },
      2: {
        shareType: 2,
        title: `熊猫签证送你￥${inviteInfo.max_reduce / 100} 新人大礼！`,
        content: `现在加入，立刻获得￥${
          inviteInfo.max_reduce / 100
        }新人大礼！优惠体验足不出户办签证！`,
        image: 'http://web.11visa.com/pdv/imgs/yaoqing-icon2.png',
        url: `https://${dev}h5.11visa.com/#/invite?uid=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
      },
      3: {
        shareType: 3,
        title: `熊猫签证送你￥${
          inviteInfo.max_reduce / 100
        } 新人大礼！优惠体验足不出户办签证！`,
        content: `熊猫签证送你￥${
          inviteInfo.max_reduce / 100
        } 新人大礼！优惠体验足不出户办签证！`,
        image: 'http://web.11visa.com/pdv/imgs/yaoqing-icon2.png',
        url: `https://${dev}h5.11visa.com/#/invite?uid=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
      },
      4: {
        shareType: 4,
        title: '我正在用熊猫签证APP办理签证，非常好用，推荐给你！',
        content: '熊猫签证-足不出户办签证！',
        image: 'http://web.11visa.com/pdv/imgs/yaoqing-icon2.png',
        url: `https://${dev}h5.11visa.com/#/invite?uid=${mobilePhone}&dev=${
          env === 1 ? 1 : 0
        }`,
      },
    };
  }
}
